import PropTypes from 'prop-types';
import React, { Component } from 'react';
import LoadingContainerComponent from "~/components/LoadingContainer/LoadingContainer";
import Loading from "~/ui/Loading/Loading";
import omit from 'lodash/omit';
//import get from 'lodash/get';
import cn from 'classnames';
//import css from './css.css';

export default class LoadingContainer extends Component {
	static propTypes = {
		containerClassName: PropTypes.string
	};

	render() {
		return (
			<Loading {...omit(this.props, ['containerClassName'])} className={cn(this.props.containerClassName, this.props.className)}>
				<LoadingContainerComponent containerClassName={this.props.containerClassName}>
					{this.props.children}
				</LoadingContainerComponent>
            </Loading>
		);
	}
}